import { render, staticRenderFns } from "./DialogContactos.vue?vue&type=template&id=27216d78&scoped=true"
import script from "./DialogContactos.vue?vue&type=script&lang=js"
export * from "./DialogContactos.vue?vue&type=script&lang=js"
import style0 from "./DialogContactos.vue?vue&type=style&index=0&id=27216d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27216d78",
  null
  
)

export default component.exports